<template>
  <div class="app-layout__menu" v-if="isVerticalMenuActive">
    <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 v-show="!isVerticalMenuCollapsed">Sidebar</h4>
        <b-link class="nav-link modern-nav-toggle">
          <feather-icon
            icon="FilterIcon"
            size="20"
            class="collapse-toggle-icon"
            @click="toggleVerticalMenu"
            v-show="isVerticalMenuCollapsed"

          />
          <feather-icon
            icon="XIcon"
            size="20"
            class="collapse-toggle-icon"
            @click="toggleVerticalMenu"
            v-show="!isVerticalMenuCollapsed"
          />
        </b-link>
      </div>
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scroll-area"
    >
      <slot name="content"></slot>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BCard, BLink, BSidebar } from 'bootstrap-vue'




export default {
  components: {
    BCard,
    VuePerfectScrollbar,
    BLink,
    BSidebar,

  },

  props: {
    isVerticalMenuActive: {
      type: Boolean,
      default: true,
      required: false,
    },
    isVerticalMenuCollapsed: {
      type: Boolean,
      default: true,
      required: false,
    },
    toggleVerticalMenu: {
      type: Function,
      default: ()=>{},
      required: false,
    }
  },

  setup() {

    const perfectScrollbarSettings = {
      maxScrollbarLength: 0,
      wheelPropagation: false,
    }


    return {
      perfectScrollbarSettings,
    }
  },
}
</script>

<style lang="scss">
    @import '@core/scss/base/bootstrap-extended/include'; // Bootstrap includes

    .app-layout--boxed .app-layout__menu {
        background-color: white;
        padding: 1.5rem;
        border-radius: $card-border-radius;
    }


    .app-layout__menu {
        margin-right: 20px;
        transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    }

    .app-layout__menu .scroll-area {
        position: relative;
        height: 100%;
        padding-bottom: 100px;
    }

</style>

